// CardSection.js
import React from 'react';
import TextField from '../../artzu-ui/src/TextField'
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement
} from 'react-stripe-elements';

const CardSection = ({ holder, onHolderChange }) => (
  <div className="card-form">
    <div className="card-holder">
      <div className="cardSection__holder--title">Name of Card Holder</div>
      <TextField placeholder="Enter Name" width="100%" highlightColor="#dedede" style={{fontSize: "14px"}} value={holder} onChange={e => onHolderChange(e.target.value)} />
    </div>
    <div className="card-number">
      <div className="cardSection__number--title">Card Number</div>
      <CardNumberElement placeholder="0000 0000 0000 0000" className="cardSection__input" />
    </div>
    <div className="exp-date">
      <div className="exp-month">
        <div className="cardSection__date--title">Expiry Date</div>
        <CardExpiryElement className="cardSection__input cardSection__input--fit" />
      </div>
      <div className="card-cvc">
        <div className="cardSection__cvc--title">CVC</div>
        <CardCVCElement placeholder="000" className="cardSection__input" />
      </div>
    </div>
  </div>
);

export default CardSection;



// WEBPACK FOOTER //
// ./src/components/NewPayments/CardSection.js